(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.api.logout.factory:LogoutFactory
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.logout')
    .factory('LogoutFactory', LogoutFactory);

  function LogoutFactory(AdmConstant, DataFactory) {
    var api = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'j_spring_security_logout';
    
    var LogoutBase = {

      get: function(){
        return DataFactory.get(api);
      }
      
    };
    return LogoutBase;
  }
}());
